import { ServiceBase } from "@app/shared";
import { SortDirections } from "@app/shared/waffles";

import { AddSoftwareLicense, AddSoftwareLicensedProducts, AddSoftwareLicenseUsers, ClientLicenseOverviews, LicenseClientList } from "./clientLicenseModels";
import { querystringify } from "@app/shared/utility";

/** Manages access to CRUD functionality for Client License. */
export default class ClientLicenseService extends ServiceBase {

  public async getClientLicenseCounts(skip: number, take: number, sortDirection: SortDirections = SortDirections.None, sortedColumn?: string, nameFilter?: string, numLicenseFilter?: string, isActiveOnlyFilter = false): Promise<LicenseClientList> {
    const query = {
      isActiveOnlyFilter,
      nameFilter,
      numLicenseFilter,
      offset: skip,
      pageSize: take,
      sortDirection,
      sortedColumn,
    }

    const licenseClientList = await this.makeGet<LicenseClientList>(`licenses/counts?${querystringify(query)}`);

    return licenseClientList;
  }

  public async getClientSoftwareLicenseOverviews(clientId: string): Promise<ClientLicenseOverviews> {
    const details = await this.makeGet<ClientLicenseOverviews>(`licenses/${clientId}/overview`);

    return details;
  }

  public async addSoftwareLicense(license: AddSoftwareLicense): Promise<void> {
    await this.makePost(`licenses`, license);
  }

  public async addSoftwareLicensedProducts(licenceId: number, product: AddSoftwareLicensedProducts): Promise<void> {
    await this.makePost(`licenses/${licenceId}/product`, product);
  }

  public async addSoftwareLicenseUsers(licenceId: number, user: AddSoftwareLicenseUsers): Promise<void> {
    await this.makePost(`licenses/${licenceId}/user`, user);
  }

  public async terminateSoftareLicense(licenseId: number): Promise<void> {
    await this.makeDelete(`licenses/${licenseId}`);
  }

  public async terminateSoftwareLicenseUser(licenseId: number, licenseUserId: number): Promise<void> {
    await this.makeDelete(`licenses/${licenseId}/user/${licenseUserId}`);
  }

  public async terminateSoftwareLicensedProduct(licenseId: number, licenseProductId: number): Promise<void> {
    await this.makeDelete(`licenses/${licenseId}/product/${licenseProductId}`);
  }

  public async setCanDownload(licenseId: number, licenseUserId: number, canDownload: boolean): Promise<void> {
    await this.makePut(`licenses/${licenseId}/user/${licenseUserId}/can-download/${canDownload}`);
  }
}
